import React from 'react';
export function Footer() {
  return <footer className="px-6 pb-9 pt-7 text-center text-[12px] font-semibold text-white/35" data-id="element-40">
      COFIT © 2026 — PROTEÍNA FUNCIONAL CERTIFICADA POR ANMAT. HECHO EN
      ARGENTINA.
    </footer>;
}